import React from 'react';
import { PopoverOption } from '../../../../shared/PopoverMenu';
import { useTree } from './map-helpers/hooks/useTree';
import { Popover } from './Popover';
import { ReactComponent as BombIcon } from '../../../../images/icons/bomb-solid.svg';

type Props = {
  nodeId: string;
  className?: string;
};

export const NukePopover = ({ nodeId, className }: Props) => {
  const { markNodeAndChildrenForDeletion, deleteNodeAndChildren, unmarkForDeletionAllNodes } = useTree();

  const handleMarkForNuke = () => {
    markNodeAndChildrenForDeletion(nodeId);
  };

  const handleNuke = () => {
    deleteNodeAndChildren(nodeId);
  };

  const handleUnmark = () => {
    unmarkForDeletionAllNodes();
  };

  const options: Array<PopoverOption> = [
    { name: 'Confirm Section Removal', onClick: handleNuke, icon: 'Tick', dataTestId: '' },
    { name: 'Cancel', onClick: handleUnmark, icon: 'Cross', dataTestId: '' },
  ];

  const tooltipLabel = 'Remove entire section';

  return (
    <Popover
      tooltipLabel={tooltipLabel}
      icon={<BombIcon title={tooltipLabel} />}
      options={options}
      onMenuOpen={handleMarkForNuke}
      onClickAway={handleUnmark}
      className={className}
    />
  );
};
